/*---------------------------------------*\
   Import classes
\*---------------------------------------*/

//Components
import {Header} from "./Components/Header";
import {ShareArticle} from "./Components/ShareArticle";

/*---------------------------------------*\
   Init Functions
\*---------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
    // Float label for smartEmailing form
    Header.init();
    ShareArticle.init();
});
